module.exports = __webpack_public_path__ + "顾荣辉-8ed33c66.png";